import { Alert, Button, Group, Skeleton, Text } from "@mantine/core";
import { IconWallet } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import useDashboardAccess from "@/hooks/useDashboardAccess";
import walletService from "@/services/wallet";
import classes from "./campaign.module.css";

export function useCampaignWallet() {
  const { isResolved } = useDashboardAccess();
  return useQuery(["getWalletBalance"], walletService.getWalletBalance, {
    enabled: isResolved,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  });
}

export default function CampaignWallet() {
  const wallet = useCampaignWallet();
  return <div className={classes.wallet} aria-live="polite">
    <Group gap="sm" wrap="nowrap"><IconWallet size={23} /><div>
      <Text size="xs" c="dimmed">موجودی اعتبار پیامکی</Text>
      {wallet.isLoading ? <Skeleton width={115} height={22} mt={6} /> : wallet.data?.amount !== undefined ?
        <Text fw={800} size="lg">{wallet.data.amount.toLocaleString("fa-IR")} <Text span size="xs" fw={400}>ریال</Text></Text> :
        <Text size="sm" c="red">موجودی دریافت نشد</Text>}
    </div></Group>
    {wallet.isError && <Alert color="red" mt="sm" p="xs"><Button size="compact-sm" variant="subtle" onClick={() => void wallet.refetch()}>تلاش دوباره</Button></Alert>}
  </div>;
}
